"use client";

import React from "react";
import Image from "next/image";
import Link from "next/link";
import ScrollReveal from "@/components/common/ScrollReveal";
import SubpageBackground from "@/components/common/SubpageBackground";

const Resource = () => {
  const resources = [
    {
      id: "zero-day",
      title: "Zero-Day Tracker",
      description: "Tracking ECQ's zero-day or unpublished vulnerabilities.",
      image: "/images/Resource/zero_day_tracker.svg",
      href: "/resources/zero-day-tracker",
      cornerClass: "md:rounded-tl-[40px]",
    },
    {
      id: "advisories",
      title: "Security Advisories",
      description: "ECQ's public security advisories for various products.",
      image: "/images/Resource/security_advisories.svg",
      href: "/resources/security-advisories",
      cornerClass: "",
    },
    {
      id: "white-paper",
      title: "White Paper",
      description: "Security white papers written by ECQ Consultants over the years.",
      image: "/images/Resource/white_paper.svg",
      href: "/resources/white-paper",
      cornerClass: "md:rounded-tr-[40px]",
    },
  ];

  return (
    <div className="relative w-full min-h-screen overflow-hidden">
      <SubpageBackground />

      {/* Site content column: px-4 sm:px-6 lg:px-8 gutters around a 1300px box,
          same as the other Resources pages and the footer. Tailwind's `container`
          capped this at 1280px and kept a flat 16px gutter, putting the content
          edge 26px inboard of every other page. */}
      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-8 pt-[80px] pb-12 sm:pb-16 md:pb-20 lg:pb-24">
        <div className="max-w-[1300px] mx-auto">
          <div className="text-center mb-12">
            <ScrollReveal direction="up" delay={0}>
              <h1 className="text-text-highlight font-bold text-[28px] sm:text-[44px] lg:text-[55px] leading-tight mb-6">
                Resources
              </h1>
            </ScrollReveal>

            <ScrollReveal direction="up" delay={100}>
              <p className="body-1 text-text-highlight max-w-3xl mx-auto">
                Security researches, zero-day vulnerability tracker, and white papers by ECQ team
                can be found here.{" "}
              </p>
            </ScrollReveal>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-1 mt-12 drop-shadow-[17px_13px_15px_rgba(0,0,0,0.3)]">
            {resources.map((resource, index) => (
              <ScrollReveal key={resource.id} direction="up" delay={200 + index * 100}>
                <Link
                  href={resource.href}
                  className={`flex flex-col justify-center items-center w-full h-auto min-h-[340px] p-5 gap-4 sm:h-[500px] sm:p-[32px] sm:gap-[24px] text-center bg-gradient-to-b from-[#2E353A] from-[13.725%] to-[#15181D] transition-all duration-300 group ${resource.cornerClass}`}
                >
                  <Image
                    src={resource.image}
                    alt={resource.title}
                    width={200}
                    height={200}
                    className="w-[150px] h-[150px] sm:w-[200px] sm:h-[200px] object-contain transition-transform duration-500 group-hover:scale-110"
                  />

                  {/* Mobile drops to 20/28 and allows wrapping: the longest title
                    ("Security Advisories") measures 260px at 28px, which still
                    fits the 294px content box at a 390px viewport but breaks out
                    of it at <=340px. whitespace-normal keeps the tile intact
                    there; the nowrap single line returns at sm. */}
                  <h3 className="text-text-highlight font-bold text-[20px] leading-[28px] whitespace-normal sm:text-[28px] sm:leading-[44px] sm:whitespace-nowrap">
                    {resource.title}
                  </h3>

                  <p className="body-1 text-text-highlight text-center w-[292px] max-w-full">
                    {resource.description}
                  </p>
                </Link>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resource;
